module.exports = __webpack_public_path__ + "static/media/question.846f3150.gif";